import type { JSX, PropsWithChildren } from 'react';

import {
	PetitionDetailsPageDataContextProvider,
	PetitionDetailsPageFcmContextProvider,
	PetitionDetailsPageUserDataContextProvider,
} from 'src/app/pages/petitionDetails/pageContext';

import { PetitionStatsStateProvider } from '../../../hooks/petitionStats';

import type { MobileModalContext } from './types';

export function MobileModalContextDecorator({
	stats,
	pageData,
	pageUserData,
	fcm,
	children,
}: PropsWithChildren<MobileModalContext>): JSX.Element {
	return (
		<PetitionStatsStateProvider value={stats}>
			<PetitionDetailsPageDataContextProvider pageData={pageData}>
				<PetitionDetailsPageUserDataContextProvider pageUserData={pageUserData}>
					<PetitionDetailsPageFcmContextProvider pageFcm={fcm}>{children}</PetitionDetailsPageFcmContextProvider>
				</PetitionDetailsPageUserDataContextProvider>
			</PetitionDetailsPageDataContextProvider>
		</PetitionStatsStateProvider>
	);
}
